var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F0EAD5",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.012 6.73a.894.894 0 0 0-1.176.43.844.844 0 0 0-.025.655.868.868 0 0 0 .465.489c3.412 1.517 5.37 4.615 5.37 8.502 0 5.312-4.405 9.634-9.82 9.634-5.412 0-9.817-4.322-9.817-9.634 0-3.876 1.97-6.975 5.406-8.502a.87.87 0 0 0 .466-.49.841.841 0 0 0-.024-.654.89.89 0 0 0-.81-.508.89.89 0 0 0-.366.077c-4.036 1.795-6.446 5.562-6.446 10.077 0 6.266 5.2 11.364 11.592 11.364 6.391 0 11.59-5.098 11.59-11.364 0-4.525-2.394-8.293-6.405-10.077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.377 15.168a.916.916 0 0 0-.642.263.86.86 0 0 0-.267.615c0 .227.094.446.265.613l5.461 5.378c.342.34.94.338 1.282 0l5.443-5.374a.867.867 0 0 0 .267-.617.865.865 0 0 0-.267-.615.913.913 0 0 0-1.284 0l-3.905 3.83V5.111c0-.482-.405-.876-.903-.876a.89.89 0 0 0-.903.876v14.15l-3.905-3.83a.913.913 0 0 0-.642-.263"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineDownload);
export default __webpack_public_path__ + "static/media/offline-download.190915ab6806c328eefc26104fe2c67b.svg";
export { ForwardRef as ReactComponent };